/**
 * Utility functions for date manipulation in the Australia/Sydney timezone.
 */

/**
 * Calculates the date of the next occurrence of a specific day of the week
 * in the Australia/Sydney timezone, formatted as YYYY-MM-DD.
 * 
 * @param dayOfWeek - 0 (Sunday) to 6 (Saturday)
 * @returns Date string in YYYY-MM-DD format
 */
export function getNextSydneyDate(dayOfWeek: number): string {
  const now = new Date();
  
  // Get the current date string in Sydney (YYYY-MM-DD)
  const sydneyDateString = new Intl.DateTimeFormat('en-CA', { 
    timeZone: 'Australia/Sydney', 
    year: 'numeric', 
    month: '2-digit', 
    day: '2-digit' 
  }).format(now);
  
  // Create a Date object representing the start of today in Sydney
  const currentSydneyDate = new Date(sydneyDateString + 'T00:00:00');
  const currentDay = currentSydneyDate.getDay();
  
  const dayOffset = (dayOfWeek - currentDay + 7) % 7;
  const nextDate = new Date(currentSydneyDate);
  nextDate.setDate(nextDate.getDate() + dayOffset);
  
  // Format back to YYYY-MM-DD using Sydney timezone to avoid UTC shifts
  return new Intl.DateTimeFormat('en-CA', { 
    timeZone: 'Australia/Sydney', 
    year: 'numeric', 
    month: '2-digit', 
    day: '2-digit' 
  }).format(nextDate);
}

/**
 * Returns the current date in Australia/Sydney, formatted as YYYY-MM-DD.
 */
export function getCurrentSydneyDate(): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Australia/Sydney',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
}

/**
 * Returns the current time in Australia/Sydney, formatted as HH:MM (24-hour).
 */
export function getCurrentSydneyTime(): string {
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Australia/Sydney',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(new Date());
}
